import { useCallback, useEffect } from "react";
import { usePersistentState } from "./usePersistentState.jsx";

const SCRIPT_VERSION_KEY = "ae_script_version";

export const useScriptVersion = (defaultValue = "") => {
  const validator = useCallback(
    (value) => (typeof value === "string" ? value : defaultValue),
    [defaultValue],
  );

  const [version, setVersion] = usePersistentState(SCRIPT_VERSION_KEY, defaultValue, {
    raw: true,
    validator,
  });

  const updateVersion = useCallback(
    (nextValue) => {
      const normalizedValue = typeof nextValue === "string" ? nextValue : "";
      setVersion(normalizedValue);
    },
    [setVersion],
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleVersionBroadcast = (event) => {
      if (!event?.detail) return;
      updateVersion(event.detail);
    };

    window.addEventListener("ae-script-version", handleVersionBroadcast);
    return () => {
      window.removeEventListener("ae-script-version", handleVersionBroadcast);
    };
  }, [updateVersion]);

  return [version, updateVersion];
};

export default useScriptVersion;
